export default {
  // 新增提货订单
  insertYxPickupOrder: '/ygsjzs/yxPickupOrder/insertYxPickupOrder',
  // 修改提货订单
  updateYxPickupOrder: '/ygsjzs/yxPickupOrder/updateYxPickupOrder',
  // 审批提货订单
  approvalYxPickupOrder: '/ygsjzs/yxPickupOrder/approvalYxPickupOrder',
  // 删除提货订单
  deleteYxPickupOrder: '/ygsjzs/yxPickupOrder/deleteYxPickupOrder',
  // 查询提货订单详情
  selectYxPickupOrderByPickupId: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPickupId',
  // 分页查询提货订单列表
  selectYxPickupOrderByPage: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPage',
  // 导出
  exportYxPickupOrder: '/ygsjzs/yxPickupOrder/exportYxPickupOrder',
  updateYxPlanPickupOrder: '/ygsjzs/yxPickupOrder/updateYxPlanPickupOrder',
  // 修改车辆
  updateYxPlanVehicle: '/ygsjzs/yxPickupOrder/updateYxPlanVehicle',
  // 确认装货
  editCYWlVehiclePlanCc: '/ygsjzs/wlVehiclePlan/editCYWlVehiclePlanCc'
}
